<div [innerHTML]="contentService.getIcon(statesService.getComponentState(component) ? statesService.getComponentState(component) : component) | safeHtml"
    (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
</div>